import { useState, useEffect } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { supabase } from '@/integrations/supabase/client';

interface PEOProvider {
  id: string;
  name: string;
}

export const usePEOProvider = () => {
  const { user, userRole } = useAuth();
  const [peoProvider, setPeoProvider] = useState<PEOProvider | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchPEOProvider = async () => {
      if (!user?.id || userRole !== 'peo') {
        setIsLoading(false);
        return;
      }

      try {
        // Get PEO provider info for the current user
        const { data, error } = await supabase
          .from('peo_representatives')
          .select(`
            provider_id,
            peo_providers!inner(id, name)
          `)
          .eq('user_id', user.id)
          .eq('verification_status', 'verified')
          .single();

        if (error) {
          console.error('Error fetching PEO provider:', error);
          return;
        }

        if (data?.peo_providers) {
          setPeoProvider({
            id: data.peo_providers.id,
            name: data.peo_providers.name
          });
        }
      } catch (error) {
        console.error('Error in fetchPEOProvider:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchPEOProvider();
  }, [user?.id, userRole]);

  return {
    peoProvider,
    isPEOUser: userRole === 'peo',
    isLoading
  };
};